import { render, staticRenderFns } from "../../templates/card/animal-card.pug?vue&type=template&id=00a472d8&scoped=true&lang=pug&"
import script from "./AnimalCard.vue?vue&type=script&lang=js&"
export * from "./AnimalCard.vue?vue&type=script&lang=js&"
import style0 from "./AnimalCard.vue?vue&type=style&index=0&id=00a472d8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a472d8",
  null
  
)

export default component.exports